module.exports = __webpack_public_path__ + "img/138.2.bc0346c1.png";